module.exports = __webpack_public_path__ + "img/pic_02_nor.9915dc3e.png";